import { useState } from 'react';
import { Music, Download } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { api } from '../../lib/api';
import { ArtistAdminCard } from './ArtistAdminCard';

export function ArtistsTab({ artists, openArtistDialog, handleToggleActive, handleApproveArtist, handleSendSetupEmail, handleRegenerateToken, handleToggleVerification, handleDeleteArtist, setAudioArtistId, setAudioDialogOpen, setLinkArtistId, setLinkDialogOpen }) {
  const [exporting, setExporting] = useState(false);

  const handleExportCsv = async () => {
    setExporting(true);
    try {
      const res = await api.exportArtistsCsv();
      const url = URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `tune4tune_artists_${new Date().toISOString().slice(0, 10)}.csv`;
      link.click();
      URL.revokeObjectURL(url);
      toast.success('Artist CSV downloaded');
    } catch (e) {
      toast.error('Export failed');
    } finally {
      setExporting(false);
    }
  };

  if (artists.length === 0) {
    return (
      <div className="text-center py-16 bg-surface rounded-2xl border border-[#262626]">
        <Music className="w-16 h-16 mx-auto mb-4 text-[#333]" />
        <h3 className="text-xl font-heading font-bold mb-2">No Artists Yet</h3>
        <p className="text-[#A1A1AA] mb-6">Add your first artist</p>
        <div className="flex justify-center gap-3">
          <Button onClick={() => openArtistDialog()} className="btn-primary">Add Artist</Button>
        </div>
      </div>
    );
  }

  const handlers = {
    handleToggleActive, handleApproveArtist, handleSendSetupEmail, handleRegenerateToken,
    handleToggleVerification, handleDeleteArtist, openArtistDialog,
    setAudioArtistId, setAudioDialogOpen, setLinkArtistId, setLinkDialogOpen
  };

  return (
    <>
      <div className="flex justify-end mb-4">
        <Button onClick={handleExportCsv} disabled={exporting} variant="outline" className="border-[#262626]" data-testid="export-artists-csv-btn">
          <Download className="w-4 h-4 mr-2" />
          {exporting ? 'Exporting...' : 'Export CSV'}
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {artists.map((artist) => (
          <ArtistAdminCard key={artist.id} artist={artist} handlers={handlers} />
        ))}
      </div>
    </>
  );
}
